import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">MySepticPump · Your Trusted Septic Solutions</p>
        <h1>Welcome to MySepticPump</h1>
        <p className="lede">
          Your reliable partner for septic pump services. We ensure your system runs smoothly and efficiently, providing peace of mind for your home.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Fast and Reliable Service</h2>
          <p>
            Our team is dedicated to providing prompt and dependable septic pump services, ensuring your system is always in top condition.
          </p>
        </article>
        <article>
          <h2>Expert Technicians</h2>
          <p>
            With years of experience, our certified technicians are equipped to handle all your septic needs with professionalism and care.
          </p>
        </article>
        <article>
          <h2>Comprehensive Solutions</h2>
          <p>
            From routine maintenance to emergency repairs, we offer a full range of septic services tailored to your specific requirements.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;